var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{attrs:{"length":_vm.pageTotal,"prev-icon":"mdi-chevron-left","next-icon":"mdi-chevron-right","total-visible":5},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }